import { apiAxios } from "../utils/request.js";
//获取OSS文件上传信息
export const fileSts = (data, Istoast = false, Send = false) => {
  return apiAxios("post", "/shopapi/file/sts", data, Istoast, Send);
};
